import React, { useState } from "react";
import { Button } from "antd";
import ReactJsonViewer from "app/lib/utils/ReactJsonViewer";
import mongoQueriesService from './MongoQueriesService';

export const NewMongoQueryDetails = ({ _id, ...props }, form) => {
    const [queryResult, setQueryResult] = useState([]);
    const onRunQuery = async () => {
        try {
            const values = await form.validateFields();
            const queryresult = await mongoQueriesService.runMongoQuery(values);
            setQueryResult(queryresult)
        } catch (error) {
            console.log("error", error);
        }
    }

    return (
        <div>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-around" }}>
                <Button type="primary" onClick={onRunQuery}>Run</Button>
            </div>
            <div style={{ textAlign: "left" }}>
                <ReactJsonViewer height={"175px"} src={queryResult} collapsed={true} />
            </div>
        </div>
    )
}